import React from 'react';
import { Outlet } from '@tanstack/react-router';
import { Loader } from 'shared-portal-components-v2';

import AuthHeader from '@/components/molecules/AuthHeader/AuthHeader';
import AuthFooter from '@/components/molecules/AuthFooter/AuthFooter';
import { useGlobalLoader } from '@/hooks/useGlobalLoader';

const AuthLayout: React.FC = () => {
  const { state } = useGlobalLoader();

  return (
    <div className="transition-all duration-300">
      <div className="min-h-screen bg-background flex flex-col">
        <AuthHeader />

        <main className="flex-1 flex items-center justify-center px-8 py-12 lg:px-12">
          <div className="w-full max-w-md">
            <div className="mb-8">
              <Outlet />
            </div>

            <AuthFooter />
          </div>
        </main>

        <Loader isVisible={state.show} />
      </div>
    </div>
  );
};

export default AuthLayout;
